import getRelatedClassName from './get-related-class-name';

const addRelatedClassName = (node) => {
  node.classList.add(getRelatedClassName(node.tagName.toLowerCase()));
};

export default addRelatedClassName;
